import { render } from "./AmplitudeSync.vue?vue&type=template&id=4585214d"
import script from "./AmplitudeSync.vue?vue&type=script&lang=js"
export * from "./AmplitudeSync.vue?vue&type=script&lang=js"

import "./AmplitudeSync.vue?vue&type=style&index=0&id=4585214d&lang=css"

import exportComponent from "E:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__